// ============================================================================
// morale.js — a single global morale bar (0..100, 50 = even). Kills, captures
// and warlord deaths swing it; crowd_ai reads it to embolden the winning side.
// Event-driven: initMorale() subscribes once and never touches the hot loop.
// ============================================================================

import {
  MORALE_MAX, MORALE_KILL, MORALE_PLAYER_KILL, MORALE_CAPTURE, MORALE_WARLORD,
  MORALE_ALLY_LOSS, TEAM_PLAYER, TEAM_MAGMAR,
} from '../core/constants.js';
import { clamp } from '../core/math.js';
import { EV } from '../core/events.js';

export function shiftMorale(world, delta) {
  const before = world.morale;
  world.morale = clamp(world.morale + delta, 0, MORALE_MAX);
  if (world.morale !== before) world.events.emit(EV.MORALE, { value: world.morale });
}

export function initMorale(world) {
  world.events.on(EV.KILL, ({ team, byPlayer }) => {
    if (team === TEAM_MAGMAR) shiftMorale(world, byPlayer ? MORALE_PLAYER_KILL : MORALE_KILL);
    else if (team === TEAM_PLAYER) shiftMorale(world, MORALE_ALLY_LOSS);
  });
  world.events.on(EV.BASTION_CAPTURED, ({ team }) => {
    shiftMorale(world, team === TEAM_PLAYER ? MORALE_CAPTURE : -MORALE_CAPTURE);
  });
  world.events.on(EV.WARLORD_SLAIN, ({ team }) => {
    shiftMorale(world, team === TEAM_MAGMAR ? MORALE_WARLORD : -MORALE_WARLORD);
  });
}
